import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=b6908ca4&scoped=true&"
import script from "./Impersonate.vue?vue&type=script&lang=js&"
export * from "./Impersonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6908ca4",
  null
  
)

export default component.exports